/* Tyres Direct V2 (Fast Lane): behaviour for the help and content pages (approved mockups b/cnt.js, brands.html,
   agreed by Adil 15 Oct 2026). Needs tdx.js (window.TDX). Vanilla JS, idempotent.
   - Side rail: marks the section in view (aria-current); FAQ: a link to a group opens its first question.
   - Delivery postcode checker: the Parcelify zones (copied from the round 1 to 3 td-delivery section; change the
     prices in the section settings, the postcode ranges here, when Parcelify changes). Dispatch day, then the DHL
     estimate as the rates name it (Adil, 15 Oct): 1 to 2 working days, 2 to 3 for the Highlands and Islands, the
     Isles of Scilly and Northern Ireland.
   - Brands page: find a brand, tier tabs, A to Z jump, ?q= from the header's brand search.
   - Shopify policy pages: rebuilds .shopify-policy__container into the night hero, rail and prose layout.
     Facts for the help card come from window.TDX_FACTS {phone, email, hours, help} when the layout sets it,
     else from the footer's tel: and mailto: links. */
(function () {
  const start = () => {
    const X = window.TDX; if (!X) return;
    const { $, $$, ic } = X;
    const slug = s => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    /* ---------- Shopify policy pages ---------- */
    const pol = $('.shopify-policy__container');
    if (pol && !pol.classList.contains('tdx-pol')) {
      const h1 = $('.shopify-policy__title h1', pol) || $('h1', pol);
      const title = h1 ? h1.textContent.trim() : '';
      const rte = $('.shopify-policy__body .rte', pol) || $('.shopify-policy__body', pol);
      if (rte) {
        const F = window.TDX_FACTS || {};
        const tel = $('footer a[href^="tel:"], .ftr a[href^="tel:"]');
        const mail = $('footer a[href^="mailto:"], .ftr a[href^="mailto:"]');
        const phone = F.phone || (tel ? tel.textContent.trim() : '');
        const email = F.email || (mail ? mail.getAttribute('href').replace(/^mailto:/, '') : '');
        const hrs = $('.ftr .em span, footer .em span');
        const hours = F.hours || (hrs ? hrs.textContent.trim() : '');
        /* Shopify's own policy text comes wrapped in one bare <div>: unwrap it so the H2s are direct children */
        const bare = el => el.children.length === 1 && el.firstElementChild.tagName === 'DIV' && ![...el.childNodes].some(n => n.nodeType === 3 && n.textContent.trim());
        while (bare(rte)) { const w = rte.firstElementChild; while (w.firstChild) rte.insertBefore(w.firstChild, w); w.remove(); }
        let updated = '';
        const first = rte.firstElementChild;
        if (first && first.tagName === 'P' && first.textContent.trim().length < 80 && /^Last updated/i.test(first.textContent.trim())) { updated = first.textContent.trim(); first.remove(); }
        const h2s = $$('h2', rte);
        h2s.forEach(h => { if (!h.id) h.id = slug(h.textContent); });
        const help = (phone || email) ? `<div class="help"><div class="c-help"><b>Still need help?</b>${phone ? `<a class="c-tel" href="tel:${phone.replace(/\s/g, '')}">${ic('phone')}${esc(phone)}</a>` : ''}${hours ? `<p>${esc(hours)}</p>` : ''}${email ? `<a class="em" href="mailto:${esc(email)}">${esc(email)}</a>` : ''}</div></div>` : '';
        const LIST = [['Returns and refunds', '/policies/refund-policy'], ['Delivery and shipping', '/policies/shipping-policy'], ['Terms of service', '/policies/terms-of-service'], ['Privacy policy', '/policies/privacy-policy'], ['Cookie policy', '/pages/cookies'], ['Contact information', '/policies/contact-information']];
        const rail = h2s.length >= 5
          ? `<nav class="c-rail" aria-label="On this page"><p class="k">On this page</p>${h2s.map(h => `<a href="#${h.id}">${esc(h.textContent.trim())}</a>`).join('')}${help}</nav>`
          : `<nav class="c-rail" aria-label="Policies"><p class="k">Policies</p>${LIST.map(([t, u]) => `<a href="${u}"${location.pathname === u ? ' aria-current="page"' : ''}>${t}</a>`).join('')}${help}</nav>`;
        const crumbHelp = F.help ? `<a href="${esc(F.help)}">Help centre</a>${ic('chevron-right')}` : '';
        const hero = document.createElement('section');
        hero.className = 'night c-hero';
        hero.innerHTML = `<div class="wrap"><nav class="crumb" aria-label="Breadcrumb"><a href="/">Home</a>${ic('chevron-right')}${crumbHelp}<span aria-current="page">Policies</span></nav><p class="eyebrow cap">Policies</p><h1 class="c-h1 sm">${esc(title)}</h1>${updated ? `<p class="c-meta"><span>${ic('calendar')}${esc(updated)}</span></p>` : ''}</div>`;
        const body = document.createElement('div');
        body.className = 'c-body';
        body.innerHTML = `<div class="wrap"><div class="c-cols">${rail}<div class="prose" data-pol-prose></div></div></div>`;
        const prose = $('[data-pol-prose]', body);
        while (rte.firstChild) prose.appendChild(rte.firstChild);
        pol.classList.add('tdx-pol');
        pol.replaceChildren(hero, body);
        if (location.hash.length > 1) { const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (t) t.scrollIntoView(); }
      }
    }

    /* ---------- Side rail: the section in view ---------- */
    const links = $$('.c-rail a[href^="#"]');
    if (links.length && 'IntersectionObserver' in window) {
      const map = new Map(links.map(a => [decodeURIComponent(a.getAttribute('href').slice(1)), a]));
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (!e.isIntersecting) return;
        links.forEach(a => a.removeAttribute('aria-current'));
        const a = map.get(e.target.id); if (a) a.setAttribute('aria-current', 'true');
      }), { rootMargin: '-20% 0px -70% 0px' });
      map.forEach((a, k) => { const t = document.getElementById(k); if (t) io.observe(t); });
    }

    /* ---------- FAQ: a link to a group (or an old #faq-* anchor) opens its first question ---------- */
    const openGroup = () => {
      if (location.hash.length < 2) return;
      const t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (!t) return;
      const g = t.closest('.faq-g'); if (!g) return;
      const q = $('.qa', g); if (q) q.open = true;
    };
    if ($('.faq-g')) { openGroup(); window.addEventListener('hashchange', openGroup); }

    /* ---------- Delivery: postcode checker ---------- */
    $$('[data-pc]').forEach(form => {
      const inp = $('.pc-in', form), res = $('[data-pc-res]', form);
      if (!inp || !res) return;
      const P = { ni: +form.dataset.ni || 0, hi: +form.dataset.hi || 0, iow: +form.dataset.iow || 0, ios: +form.dataset.ios || 0 };
      const cut = (form.dataset.cut || '1pm').trim();
      const AREAS = new Set('AB AL B BA BB BD BH BL BN BR BS BT CA CB CF CH CM CO CR CT CV CW DA DD DE DG DH DL DN DT DY E EC EH EN EX FK FY G GL GU HA HD HG HP HR HS HU HX IG IP IV KA KT KW KY L LA LD LE LL LN LS LU M ME MK ML N NE NG NN NP NR NW OL OX PA PE PH PL PO PR RG RH RM S SA SE SG SK SL SM SN SO SP SR SS ST SW SY TA TD TF TN TQ TR TS TW UB W WA WC WD WF WN WR WS WV YO ZE'.split(' '));
      const parse = v => {
        const s = String(v).toUpperCase().replace(/[^A-Z0-9]/g, '');
        let m = s.match(/^([A-Z]{1,2})(\d[A-Z\d]?)(\d[A-Z]{2})$/);
        if (m) return { a: m[1], d: parseInt(m[2], 10), label: `${m[1]}${m[2]} ${m[3]}` };
        m = s.match(/^([A-Z]{1,2})(\d[A-Z\d]?)$/);
        if (m) return { a: m[1], d: parseInt(m[2], 10), label: s };
        return null;
      };
      /* Zones: mirrors the live Parcelify configuration (round 1 to 3 td-delivery) */
      const zone = (a, d) => {
        const HI = ['the Scottish Highlands and Islands', P.hi, '2 to 3'];
        if (a === 'BT') return ['Northern Ireland', P.ni, '2 to 3'];
        if (a === 'HS' || a === 'ZE' || a === 'IV' || a === 'KW') return HI;
        if (a === 'AB' && ((d >= 31 && d <= 38) || (d >= 41 && d <= 56))) return HI;
        if (a === 'KA' && (d === 27 || d === 28)) return HI;
        if (a === 'PA' && ((d >= 20 && d <= 50) || (d >= 60 && d <= 88))) return HI;
        if (a === 'PH' && ((d >= 4 && d <= 44) || d === 49 || d === 50)) return HI;
        if (a === 'TR' && d >= 21 && d <= 25) return ['the Isles of Scilly', P.ios, '2 to 3'];
        if (a === 'PO' && d >= 30 && d <= 41) return ['the Isle of Wight', P.iow, '1 to 2'];
        return ['', 0, '1 to 2'];
      };
      const money = v => '£' + (v % 1 === 0 ? v : v.toFixed(2));
      const disp = days => {
        const c = X.dispatch(), then = ` Then DHL\u00a0Tracked, ${days} working days.`;
        if (c.today && document.body.dataset.tdCutoff) return `Order before ${esc(cut)} and we dispatch today.${then}`;
        const d = c.date || (() => { const n = new Date(); return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)); })();
        return `Order now and we dispatch on ${['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][d.getUTCDay()]}.${then}`;
      };
      const show = v => {
        const p = parse(v);
        const z = p && !isNaN(p.d) && AREAS.has(p.a) ? zone(p.a, p.d) : null;
        if (!z) { res.className = 'pc-res unk'; res.innerHTML = `<b>We could not check that postcode.</b><p>${ic('info')}The charge for your address shows at checkout.</p>`; return; }
        if (!z[1]) { res.className = 'pc-res'; res.innerHTML = `<b>Delivery to ${esc(p.label)} is free.</b><p>${ic('clock')}${disp(z[2])}</p>`; return; }
        res.className = 'pc-res charge';
        res.innerHTML = `<b>Delivery to ${esc(p.label)} costs ${money(z[1])}.</b><p>${ic('info')}It shows at checkout before you pay. Postcodes in ${z[0]} carry this charge.</p><p>${ic('clock')}${disp(z[2])}</p>`;
      };
      form.addEventListener('submit', e => { e.preventDefault(); show(inp.value); });
      /* Review aids (as in the mockup): #pc-free, #pc-charge, #pc-unknown */
      const demo = { '#pc-free': 'M8 8RQ', '#pc-charge': 'IV2 3AB', '#pc-unknown': 'ZZ' }[location.hash];
      if (demo) { inp.value = demo; show(demo); }
    });

    /* ---------- Brands page ---------- */
    const bd = $('[data-bd]');
    if (bd) {
      const cards = $$('.bcard', bd), secs = $$('.tier-s', bd), none = $('[data-bd-none]'), az = $('[data-az]'), q = $('[data-bq]');
      let tier = 'all', term = '';
      const apply = () => {
        let shown = 0; const letters = new Set();
        cards.forEach(c => {
          const ok = (tier === 'all' || c.dataset.tier === tier) && (!term || c.dataset.name.includes(term));
          c.hidden = !ok; if (ok) { shown++; letters.add(c.dataset.letter); }
        });
        secs.forEach(s => { const n = $$('.bcard:not([hidden])', s).length; s.hidden = !n; const el = $('.tier-h .n', s); if (el) el.textContent = n; });
        if (none) { none.hidden = !!shown; const t = $('[data-bd-term]', none); if (t) t.textContent = term; }
        if (az) $$('a[data-l]', az).forEach(a => { const on = letters.has(a.dataset.l); a.classList.toggle('off', !on); if (on) a.removeAttribute('aria-disabled'); else a.setAttribute('aria-disabled', 'true'); });
      };
      if (q) {
        const qp = new URLSearchParams(location.search).get('q');
        if (qp) { q.value = qp; term = qp.trim().toLowerCase(); }
        q.addEventListener('input', () => { term = q.value.trim().toLowerCase(); apply(); });
        q.form && q.form.addEventListener('submit', e => e.preventDefault());
      }
      document.addEventListener('click', e => {
        const t = e.target.closest('[data-bt]');
        if (t) { tier = t.dataset.bt; $$('[data-bt]').forEach(x => x.setAttribute('aria-pressed', x === t ? 'true' : 'false')); apply(); }
        const l = e.target.closest('[data-l]');
        if (l) { e.preventDefault(); const c = $(`.bcard[data-letter="${l.dataset.l}"]:not([hidden])`, bd); if (c) { c.scrollIntoView({ block: 'center' }); c.focus({ preventScroll: true }); } }
        if (e.target.closest('[data-bd-clear]')) { e.preventDefault(); term = ''; if (q) q.value = ''; apply(); }
      });
      apply();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
